/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $SuggestionQuestion = {
    properties: {
        id: {
    type: 'number',
    isRequired: true,
},
        question: {
    type: 'string',
    isRequired: true,
},
    },
};